module.exports = __webpack_public_path__ + "static/img/level_2.2bdecde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_2.png
// module id = d3+h
// module chunks = 1